import * as React from "react";
import {useState} from "react";
import "./tab1.scss";
import Button from "../../../../../../core/button/button";
import ChannelSocialMediaCard, {
    IChannelSocialMediaCard
} from "../../../../../../ui/socialmediacard/channel/channelsocialmediacard";

const Tab1 = () => {
    const [activateSocialMediaCard, setActivateSocialMediaCard] = useState("card0");
    const socialMediaItems: IChannelSocialMediaCard[] = [
        {
            image: require("../../../../../../assets/images/photos/Channel1.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        },
        {
            image: require("../../../../../../assets/images/photos/Channel2.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        },
        {
            image: require("../../../../../../assets/images/photos/Channel3.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        },
        {
            image: require("../../../../../../assets/images/photos/Channel4.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        }, {
            image: require("../../../../../../assets/images/photos/Channel5.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        }, {
            image: require("../../../../../../assets/images/photos/Channel6.png"),
            name: "شبکه ۲",
            viewer: "بیننده : ۴ میلیون",
            options: ["جمعیت استان : ۵ میلیون", "ساعت پخش : ۱۰ شب", "گویش استان : لری"],
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard,
            setActivateSocialMedia: setActivateSocialMediaCard
        },
    ]
    return (
        <div className="Tab1">
            <div className="Filter-Header">
                <div className="row">
                    <div className="col-lg-7 col-12 mb-3">
                        <div className="Content-Search-Box">
                            <input type="search" name="contentSearch" id="contentSearch"
                                   className="Content-Search-Input"
                                   placeholder="جستجو در مبان نام و آدرس وبسایت ها ..."/>
                            <img
                                src={require("../../../../../../assets/images/icons/SearchNormal.svg").default}
                                alt=""
                                className="img-fluid Content-Search-Image"/>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12 mb-3">
                        <div className="Content-Filter-Box">
                            <Button type={"filter"} action={() => {
                            }} responsive={true}>
                                مرتب سازی
                                <img src={require("../../../../../../assets/images/icons/Sort.svg").default}
                                     alt="" className="img-fluid pe-2"/>
                            </Button>
                            <Button type={"filter"} action={() => {
                            }} responsive={true}>
                                فیلتر کردن
                                <img src={require("../../../../../../assets/images/icons/Filter.svg").default}
                                     alt="" className="img-fluid pe-2"/>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {
                    socialMediaItems.map((socialMediaItem, index) => {
                        return (
                            <div key={index} className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-12 mb-3">
                                <ChannelSocialMediaCard image={socialMediaItem.image} name={socialMediaItem.name}
                                                        viewer={socialMediaItem.viewer}
                                                        options={socialMediaItem.options}
                                                        cardID={index}
                                                        activateSocialMedia={socialMediaItem.activateSocialMedia}
                                                        setActivateSocialMedia={socialMediaItem.setActivateSocialMedia}/>
                            </div>
                        );
                    })
                }
            </div>
            <div className="Result-Box d-flex justify-content-around align-items-center flex-wrap">
                <div>
                    <img src={require("../../../../../../assets/images/icons/Result.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">مجموع : </span>
                    <span className="Result-Box-Result">150,000 میلیون</span>
                </div>
                <div>
                    <img src={require("../../../../../../assets/images/icons/View.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">تخمین بازدید : </span>
                    <span className="Result-Box-Result">14,000 تا 25,000</span>
                </div>
                <div>
                    <img src={require("../../../../../../assets/images/icons/Budget.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">بودجه اولیه شما : </span>
                    <span className="Result-Box-Result">120,000 میلیون</span>
                </div>
            </div>
        </div>
    );
}

export default Tab1;